import React, {useEffect, useRef, useState} from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import SimpleFile from "./SimpleFile";
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import {checkPermission} from "../../../../../_helpers/commonFunctions";
import SimpleContextMenu from "./SimpleContextMenu";
import {formatPath, getMimeType, getParentPath, popExtension} from "../Components/constants";
import {toast} from "react-toastify";
import {setAutoPreview, setCurrentPath} from "../../../../../_reducers/cloudSlice";
import TextArea from "../../../../common/TextArea";
import {openCloud} from "../../../../../_helpers/tabOpeners";
import {ButtonGroup, Col, Row} from "react-bootstrap";
import FilePreviewerContainer from "../Components/FilePreviewerContainer";
import {FaShareFromSquare} from "react-icons/fa6";
import {FaDownload} from "react-icons/fa";

const CloudHooksModal = ({documentId, section, className}) => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const isEmron = useSelector((state) => state.ACTIVITY.isEmron);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));

    const miniBrowserRef = useRef(null);

    const [showContextMenu, setShowContextMenu] = useState(false);
    const [contextMenuX, setContextMenuX] = useState(0);
    const [contextMenuY, setContextMenuY] = useState(0);
    const [contextMenuSelection, setContextMenuSelection] = useState("");

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteName, setDeleteName] = useState("");
    const [deletePath, setDeletePath] = useState("");
    const [deleteCause, setDeleteCause] = useState("");

    const [openCloudTab, setOpenCloudTab] = useState(false);

    const [loadingPreview, setLoadingPreview] = useState(false);
    const [previewFileName, setPreviewFileName] = useState("");
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewData, setPreviewData] = useState(null);

    const miniBrowserStyle = {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        gap: "10px 10px",
        minHeight: "50vh",
        maxHeight: "60vh",
        position: "relative",
        padding: "10px",
        overflowY: "auto",
        width: "100%",
        alignItems: "flex-start",
        alignContent: "flex-start",
    }

    useEffect(() => {
        if (show) {
            fetchData();
        } else {
            if (previewOpen) closePreview();
        }
    }, [show])

    useEffect(() => {
        if (!showDeleteModal) {
            setDeleteName("");
            setDeletePath("");
            setDeleteCause("");
        }
    }, [showDeleteModal])

    useEffect(() => {
        if (openCloudTab) {
            setOpenCloudTab(false);
            dispatch(openCloud(TABS_DATA));
        }
    }, [openCloudTab])

    const fetchData = () => {
        setLoading(true);
        axios.get(`${process.env.REACT_APP_API_URL2}/cloud/get-correlated-files`, {
            headers: { "Content-Type": "application/json" },
            params: {
                documentId: documentId,
                section: section,
                company: company.id,
                year: company.year,
            }
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                setData(res.data.data);
            } else {
                setData([]);
            }
        }).catch((err) => {
            setLoading(false);
            console.log(err);
        })
    }

    const onContextMenu = (e, name = "") => {
        e.stopPropagation();
        e.preventDefault();

        const bounds = miniBrowserRef.current?.getBoundingClientRect();
        setShowContextMenu(true);
        let initX = e.clientX - bounds.left;
        if (initX + 120 > bounds.width) {
            initX -= 120;
        }
        setContextMenuX(initX);

        let initY = e.clientY - bounds.top;
        if (initY + 50 > bounds.height) {
            initY -= 50;
        }
        initY += miniBrowserRef.current.scrollTop;
        setContextMenuY(initY);

        setContextMenuSelection(name);
    }

    const handleCloseContext = () => {
        if (showContextMenu || contextMenuSelection) {
            setShowContextMenu(false);
            setContextMenuSelection("");
        }
    }

    const onOpenInCloud = () => {
        const findMatching = data.find((el) => el.name === contextMenuSelection);
        if (findMatching) {
            const path = getParentPath(findMatching.path);
            dispatch(setCurrentPath(path));
            dispatch(setAutoPreview(findMatching.name));
            setOpenCloudTab(true);
        }
    }

    const onDecorrelate = () => {
        const findMatching = data.find((el) => el.name === contextMenuSelection);
        if (findMatching) {
            axios.post(`${process.env.REACT_APP_API_URL2}/cloud/action`, {
                action: "dehook",
                currentPath: formatPath(findMatching.path),
                documentHook: {
                    _id: documentId,
                    section: section,
                },
                company: company.id,
                year: company.year,
            }).then((res) => {
                if (res.data.status === "200") {
                    toast.success("Επιτυχής ενέργεια.");
                    fetchData();
                } else {
                    toast.error(res.data.message);
                    fetchData();
                }
            }).catch((err) => {
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        }
    }

    const handleDeletion = () => {
        const findMatching = data.find((el) => el.name === contextMenuSelection);
        if (findMatching) {
            setDeletePath(findMatching.path);
            setDeleteName(findMatching.name);
            setShowDeleteModal(true);
        }
    }

    const handleSaveDeletion = () => {
        if (isEmron) {
            onEmronDelete(deletePath, deleteCause);
            setShowDeleteModal(false);
        } else {
            onFileDelete(deletePath, deleteCause);
            setShowDeleteModal(false);
        }
    }

    const onFileDelete = (path, deleteCause = "") => {
        axios.post(`${process.env.REACT_APP_API_URL2}/cloud/action`, {
            action: "deleteFile",
            currentPath: formatPath(path),
            deleteCause: deleteCause,
            company: company.id,
            year: company.year,
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής διαγραφή αρχείου.");
                fetchData();
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const onEmronDelete = (path, deleteCause = "") => {
        axios.post(`${process.env.REACT_APP_API_URL2}/cloud/action`, {
            action: "emronDelete",
            currentPath: formatPath(path),
            deleteCause: deleteCause,
            company: company.id,
            year: company.year,
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής ενέργεια.");
                fetchData();
            } else {
                toast.error(res.data.message);
                fetchData();
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const fetchFileAsBlobURL = async (fileName, filePath, attemptConversion = true) => {
        setLoading(true);
        // returns error message else blob url
        try {
            const fetchResp = await axios.post(`${process.env.REACT_APP_API_URL2}/cloud/action`, {
                action: "fetch",
                attemptConversion: String(attemptConversion),
                currentPath: formatPath(filePath),
                company: company.id,
                year: company.year,
            });
            if (fetchResp.data.status === "200") {
                const fromConversion = fetchResp.data.fromConversion;
                setLoading(false);
                const binaryString = atob(fetchResp.data.data);
                const byteArray = new Uint8Array(binaryString.split('').map((char) => char.charCodeAt(0)));
                let mimeType = getMimeType(fileName);
                if (fromConversion) mimeType = "application/pdf";

                const blob = new Blob([byteArray], { type: mimeType });
                let blobUrl = URL.createObjectURL(blob);
                if (popExtension(fileName) === "pdf" || fromConversion) blobUrl += "#navpanes=0&view=Fit";

                return blobUrl;
            } else {
                setLoading(false);
                return null;
            }
        } catch (err) {
            setLoading(false);
            return null;
        }
    }

    const onDoubleClick = async (fileName, filePath) => {
        setPreviewFileName(fileName);
        setPreviewOpen(true);
        setLoadingPreview(true);
        const data = await fetchFileAsBlobURL(fileName, filePath, true);
        setPreviewData(data);
        setLoadingPreview(false);
    }

    const openPreviewInNewTab = () => {
        try {
            window.open(String(previewData), "_blank");
        } catch (_) {
            toast.error("Σφάλμα κατά το άνοιγμα παραθύρου.");
        }
    }

    const downloadPreview = async () => {
        try {
            const link = document.createElement("a");
            link.href = String(previewData);
            link.download = previewFileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (_) {
            toast.error("Σφάλμα κατά την λήψη αρχείου.");
        }
    }

    const closePreview = () => {
        setLoadingPreview(false);
        setPreviewFileName("");
        setPreviewOpen(false);
        setPreviewData(null);
    }

    return (
        <React.Fragment>
            {checkPermission("custom-cloud", permissionsData) && (
                <React.Fragment>
                    <Button onClick={() => setShow(true)} style={{height: "50px", width: "70px", padding: "5px", pointerEvents: "auto"}} className={className}>Αρχεία</Button>

                    <Modal backdrop={"static"} show={show} onHide={() => setShow(false)} dialogClassName={"modal65PercentWidth"} style={{opacity: showDeleteModal ? "0.6" : "1"}}>
                        <Modal.Header closeButton>
                            <Modal.Title>Συσχετιζόμενα αρχεία</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {loading ? (
                                <div>Γίνεται αναζήτηση παρακαλώ περιμένετε...</div>
                            ) : (
                                <React.Fragment>
                                    <Row>
                                        <Col md={previewOpen ? 6 : 12}>
                                            {data.length === 0 ? (
                                                <div>Δεν βρέθηκαν συσχετιζόμενα αρχεία.</div>
                                            ) : (
                                                <div style={miniBrowserStyle} ref={miniBrowserRef}
                                                     onClick={() => handleCloseContext()}
                                                     onMouseLeave={() => handleCloseContext()}
                                                >
                                                    <SimpleContextMenu
                                                        show={showContextMenu}
                                                        posX={contextMenuX}
                                                        posY={contextMenuY}

                                                        onOpenInCloud={onOpenInCloud}
                                                        onDecorrelate={onDecorrelate}
                                                        onFileDelete={handleDeletion}
                                                    />
                                                    {data.map((file, idx) => (
                                                        <SimpleFile
                                                            name={file.name}
                                                            key={`simpleFile-${idx}`}
                                                            selected={contextMenuSelection === file.name || previewFileName === file.name}
                                                            onContextMenu={onContextMenu}
                                                            onDoubleClick={() => onDoubleClick(file.name, file.path)}
                                                        />
                                                    ))}
                                                </div>
                                            )}
                                        </Col>
                                        {previewOpen && (
                                            <Col md={6} className={"border-left"}>
                                                {loadingPreview ? (
                                                    <div>Γίνεται λήψη, παρακαλώ περιμένετε...</div>
                                                ) : (
                                                    <React.Fragment>
                                                        <ButtonGroup size={"sm"} className={"mb-2"} style={{width: "100%"}}>
                                                            <Button style={{width: "40%"}}
                                                                    onClick={() => openPreviewInNewTab()}>
                                                                Άνοιγμα σε νέα καρτέλα <FaShareFromSquare className={"ml-2"}/>
                                                            </Button>
                                                            <Button style={{width: "40%"}} onClick={() => downloadPreview()}>
                                                                Λήψη αρχείου <FaDownload className={"ml-2"}/>
                                                            </Button>
                                                            <Button style={{width: "20%"}} onClick={() => closePreview()} title={"Κλείσιμο"}>
                                                                <i className="fa-solid fa-xmark"></i>
                                                            </Button>
                                                        </ButtonGroup>
                                                        <FilePreviewerContainer
                                                            fileName={previewFileName}
                                                            previewData={previewData}
                                                            containerHeight={"60vh"}
                                                        />
                                                    </React.Fragment>
                                                )}
                                            </Col>
                                        )}
                                    </Row>
                                </React.Fragment>
                            )}
                        </Modal.Body>
                    </Modal>

                    <Modal backdrop={"static"} show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Διαγραφή αρχείου</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Είσαστε σίγουροι ότι θέλετε να διαγράψετε το αρχείο <strong>{deleteName}</strong>;
                            <div style={{borderTop: "1px solid lightgray"}} className={"mt-3 mb-1"}></div>
                            <TextArea
                                rows={3}
                                value={deleteCause}
                                label={"Αιτιολογία"}
                                autoComplete={"off"}
                                onChange={(e) => setDeleteCause(e.target.value)}
                            />
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" onClick={() => handleSaveDeletion()}>
                                Ναι, διαγραφή
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default CloudHooksModal;
